import * as ApiService from "@/common/service/api.service"

export const index = async (query) => {
  return await ApiService.request("get", `/api/view/personnel${query}`)
}
